import ModalsUtil from '../../../utils/modals';
import {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/wheel';

export default () => {
    const [step, setStep] = useState(1),
          {bets_amount, spin_button} = useSelector(Selector);

    const getStepClassname = () => {
        if(step === 1) return 'first';
        if(step === 2) return 'second';
        if(step === 3) return 'third';
        return '';
    }

    const step_amounts = [1000, 2000, 3000];

    const getBonusMap = () => {
        return [bets_amount >= step_amounts[0], bets_amount >= step_amounts[1], bets_amount >= step_amounts[2]];
    }

    const map = getBonusMap(),
          progress = (bets_amount / step_amounts[step-1]) * 100;

    console.log(map);

    return (
        <div className="modal modal-wheel animate__zoomIn animate__animated" data-target="wheel" style={{display: 'none'}}>
            <div className="modal-close" onClick={e => ModalsUtil.close()}></div>
            <div className={`wheel-step  ${getStepClassname()}`}></div>

            <div className="wheel">
                <div className={`spinner ${getStepClassname()}`}></div>
                <div className="overlay">
                    <div className="spin-button"></div>
                </div>

                <div className="gold"></div>
                <div className="coins"></div>
            </div>

            <div className="content">
                <div className="descriptions">
                    <div className="descriptions-content">
                        <div className="title">RULES DESCRIPTION</div>
                        1: Progress will be accumulated every time you play the game!<br /><br />
                        2: The more you play, the faster the progress bar will gain.<br/><br/>
                        3: When the progress bar is full, you can get rich rewards!<br/><br/>
                        4: There are 3 phases of Rewards, and every each is rich with rewards!<br/><br/>
                        5: Play more and get more!<br/>Come and get participate!
                    </div>
                </div>

                <div className="bonuses">
                    <div className={`bonus ${step === 1 ? 'active' : ''}`} onClick={e => setStep(1)}>
                        <div className="bonus-content">
                            <div className="bonus-gift"></div>
                        </div>

                        {!map[0] && (
                            <div className="bonus-lock">
                                <div className="lock"></div>
                            </div>
                        )}
                    </div>

                    <div className={`bonus ${step === 2 ? 'active' : ''}`} onClick={e => setStep(2)}>
                        <div className="bonus-content">
                            <div className="bonus-gift"></div>
                        </div>

                        {!map[1] && (
                            <div className="bonus-lock">
                                <div className="lock"></div>
                            </div>
                        )}
                    </div>

                    <div className={`bonus ${step === 3 ? 'active' : ''}`} onClick={e => setStep(3)}>
                        <div className="bonus-content">
                            <div className="bonus-gift"></div>
                        </div>

                        {!map[2] && (
                            <div className="bonus-lock">
                                <div className="lock"></div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="wheel-progress">
                    <div className="line" style={{width: `${progress > 100 ? 100 : (progress < 5.5 ? 5.5 : progress)}%`}}></div>
                    <div className="border"></div>
                </div>
            </div>
        </div>
    )
}